let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kWyQP")).then(() => parcelRequire('5jdOI'));